import { coreTokensData } from '@cellula/react';

const colorTokens = {
	colorNeutral0: {
		cssVar: '--cellula--color--neutral--0',
		value: '#FFFFFF',
	},
	colorNeutral100: {
		cssVar: '--cellula--color--neutral--100',
		value: '#F8F8F9',
	},
	colorNeutral200: {
		cssVar: '--cellula--color--neutral--200',
		value: '#EFEFF1',
	},
	colorNeutral300: {
		cssVar: '--cellula--color--neutral--300',
		value: '#E1E2E5',
	},
	colorNeutral400: {
		cssVar: '--cellula--color--neutral--400',
		value: '#D1D3D7',
	},
	colorNeutral500: {
		cssVar: '--cellula--color--neutral--500',
		value: '#B3B7BE',
	},
	colorNeutral600: {
		cssVar: '--cellula--color--neutral--600',
		value: '#9095A0',
	},
	colorNeutral700: {
		cssVar: '--cellula--color--neutral--700',
		value: '#6A6F7B',
	},
	colorNeutral800: {
		cssVar: '--cellula--color--neutral--800',
		value: '#555962',
	},
	colorNeutral900: {
		cssVar: '--cellula--color--neutral--900',
		value: '#464951',
	},
	colorNeutral1000: {
		cssVar: '--cellula--color--neutral--1000',
		value: '#2F3136',
	},
	colorWarning100: {
		cssVar: '--cellula--color--warning--100',
		value: '#FFF7EB',
	},
	colorWarning200: {
		cssVar: '--cellula--color--warning--200',
		value: '#FFEDD1',
	},
	colorWarning300: {
		cssVar: '--cellula--color--warning--300',
		value: '#FDDEAA',
	},
	colorWarning400: {
		cssVar: '--cellula--color--warning--400',
		value: '#F7CD7D',
	},
	colorWarning500: {
		cssVar: '--cellula--color--warning--500',
		value: '#DFB04A',
	},
	colorWarning600: {
		cssVar: '--cellula--color--warning--600',
		value: '#B68F3E',
	},
	colorWarning700: {
		cssVar: '--cellula--color--warning--700',
		value: '#886B31',
	},
	colorWarning800: {
		cssVar: '--cellula--color--warning--800',
		value: '#6C5629',
	},
	colorWarning900: {
		cssVar: '--cellula--color--warning--900',
		value: '#594623',
	},
	colorWarning1000: {
		cssVar: '--cellula--color--warning--1000',
		value: '#3B2F1A',
	},
	colorDanger100: {
		cssVar: '--cellula--color--danger--100',
		value: '#FFF6F5',
	},
	colorDanger200: {
		cssVar: '--cellula--color--danger--200',
		value: '#FFEAE7',
	},
	colorDanger300: {
		cssVar: '--cellula--color--danger--300',
		value: '#FFD8D4',
	},
	colorDanger400: {
		cssVar: '--cellula--color--danger--400',
		value: '#FFC5BE',
	},
	colorDanger500: {
		cssVar: '--cellula--color--danger--500',
		value: '#FF9C94',
	},
	colorDanger600: {
		cssVar: '--cellula--color--danger--600',
		value: '#F46864',
	},
	colorDanger700: {
		cssVar: '--cellula--color--danger--700',
		value: '#BF4746',
	},
	colorDanger800: {
		cssVar: '--cellula--color--danger--800',
		value: '#973B39',
	},
	colorDanger900: {
		cssVar: '--cellula--color--danger--900',
		value: '#7B322F',
	},
	colorDanger1000: {
		cssVar: '--cellula--color--danger--1000',
		value: '#502421',
	},
	colorSuccess100: {
		cssVar: '--cellula--color--success--100',
		value: '#F4FAF4',
	},
	colorSuccess200: {
		cssVar: '--cellula--color--success--200',
		value: '#E5F3E5',
	},
	colorSuccess300: {
		cssVar: '--cellula--color--success--300',
		value: '#CEE9CF',
	},
	colorSuccess400: {
		cssVar: '--cellula--color--success--400',
		value: '#B4DDB6',
	},
	colorSuccess500: {
		cssVar: '--cellula--color--success--500',
		value: '#84C78B',
	},
	colorSuccess600: {
		cssVar: '--cellula--color--success--600',
		value: '#38A952',
	},
	colorSuccess700: {
		cssVar: '--cellula--color--success--700',
		value: '#2A7F3D',
	},
	colorSuccess800: {
		cssVar: '--cellula--color--success--800',
		value: '#266532',
	},
	colorSuccess900: {
		cssVar: '--cellula--color--success--900',
		value: '#21532A',
	},
	colorSuccess1000: {
		cssVar: '--cellula--color--success--1000',
		value: '#1A371E',
	},
	colorInfo100: {
		cssVar: '--cellula--color--info--100',
		value: '#F5F9FD',
	},
	colorInfo200: {
		cssVar: '--cellula--color--info--200',
		value: '#E9F0FB',
	},
	colorInfo300: {
		cssVar: '--cellula--color--info--300',
		value: '#D5E3F7',
	},
	colorInfo400: {
		cssVar: '--cellula--color--info--400',
		value: '#BED5F3',
	},
	colorInfo500: {
		cssVar: '--cellula--color--info--500',
		value: '#92BAEA',
	},
	colorInfo600: {
		cssVar: '--cellula--color--info--600',
		value: '#4B9AE0',
	},
	colorInfo700: {
		cssVar: '--cellula--color--info--700',
		value: '#2E73AC',
	},
	colorInfo800: {
		cssVar: '--cellula--color--info--800',
		value: '#2A5C88',
	},
	colorInfo900: {
		cssVar: '--cellula--color--info--900',
		value: '#264C6E',
	},
	colorInfo1000: {
		cssVar: '--cellula--color--info--1000',
		value: '#1E3248',
	},
	colorPrimary100: {
		cssVar: '--cellula--color--primary--100',
		value: '#FEF7EF',
	},
	colorPrimary200: {
		cssVar: '--cellula--color--primary--200',
		value: '#F8EEE1',
	},
	colorPrimary300: {
		cssVar: '--cellula--color--primary--300',
		value: '#E9E0D4',
	},
	colorPrimary400: {
		cssVar: '--cellula--color--primary--400',
		value: '#DAD1C6',
	},
	colorPrimary500: {
		cssVar: '--cellula--color--primary--500',
		value: '#BDB6AC',
	},
	colorPrimary600: {
		cssVar: '--cellula--color--primary--600',
		value: '#9A948D',
	},
	colorPrimary700: {
		cssVar: '--cellula--color--primary--700',
		value: '#736E69',
	},
	colorPrimary800: {
		cssVar: '--cellula--color--primary--800',
		value: '#5C5854',
	},
	colorPrimary800t08: {
		cssVar: '--cellula--color--primary--800-t08',
		value: '#5C585414',
	},
	colorPrimary800t12: {
		cssVar: '--cellula--color--primary--800-t12',
		value: '#5C58541F',
	},
	colorPrimary900: {
		cssVar: '--cellula--color--primary--900',
		value: '#4B4845',
	},
	colorPrimary1000: {
		cssVar: '--cellula--color--primary--1000',
		value: '#32312F',
	},
	colorAccent100: {
		cssVar: '--cellula--color--accent--100',
		value: '#F9F7FE',
	},
	colorAccent200: {
		cssVar: '--cellula--color--accent--200',
		value: '#F2EDFE',
	},
	colorAccent300: {
		cssVar: '--cellula--color--accent--300',
		value: '#E5DCFC',
	},
	colorAccent400: {
		cssVar: '--cellula--color--accent--400',
		value: '#D8CCFB',
	},
	colorAccent500: {
		cssVar: '--cellula--color--accent--500',
		value: '#BEADF8',
	},
	colorAccent600: {
		cssVar: '--cellula--color--accent--600',
		value: '#9985F3',
	},
	colorAccent700: {
		cssVar: '--cellula--color--accent--700',
		value: '#6459EC',
	},
	colorAccent800: {
		cssVar: '--cellula--color--accent--800',
		value: '#313FE7',
	},
	colorAccent900: {
		cssVar: '--cellula--color--accent--900',
		value: '#1C32C7',
	},
	colorAccent1000: {
		cssVar: '--cellula--color--accent--1000',
		value: '#23237E',
	},
	colorAccent800t08: {
		cssVar: '--cellula--color--accent--800-t08',
		value: '#313FE714',
	},
	colorAccent800t12: {
		cssVar: '--cellula--color--accent--800-t12',
		value: '#1C32C71F',
	},
	colorFocus: {
		cssVar: '--cellula--color--focus',
		value: '#44A5FF',
	},
};

export const tokensData = {
	...coreTokensData,
	...colorTokens,
	componentIconButtonHover: {
		cssVar: '--cellula--component--icon-button--color--hover',
		value: `${colorTokens.colorNeutral800.value}14`,
	},
	componentIconButtonActive: {
		cssVar: '--cellula--component--icon-button--color--active',
		value: `${colorTokens.colorNeutral800.value}1F`,
	},
	componentIconButtonHoverInteractive: {
		cssVar: '--cellula--component--icon-button--color--hover-interactive',
		value: `var(${colorTokens.colorAccent800t08.cssVar})`,
	},
	componentIconButtonActiveInteractive: {
		cssVar: '--cellula--component--icon-button--color--active-interactive',
		value: `var(${colorTokens.colorAccent800t12.cssVar})`,
	},
	componentIconButtonHoverOnDark: {
		cssVar: '--cellula--component--icon-button--color--hover-on-dark',
		value: `${colorTokens.colorNeutral0.value}14`,
	},
	componentIconButtonActiveOnDark: {
		cssVar: '--cellula--component--icon-button--color--active-on-dark',
		value: `${colorTokens.colorNeutral0.value}1F`,
	},
	componentIconButtonHoverInfo: {
		cssVar: '--cellula--component--icon-button--color--hover-info',
		value: `${colorTokens.colorInfo800.value}14`,
	},
	componentIconButtonActiveInfo: {
		cssVar: '--cellula--component--icon-button--color--active-info',
		value: `${colorTokens.colorInfo800.value}1F`,
	},
	componentIconButtonHoverSuccess: {
		cssVar: '--cellula--component--icon-button--color--hover-success',
		value: `${colorTokens.colorSuccess800.value}14`,
	},
	componentIconButtonActiveSuccess: {
		cssVar: '--cellula--component--icon-button--color--active-success',
		value: `${colorTokens.colorSuccess800.value}1F`,
	},
	componentIconButtonHoverWarning: {
		cssVar: '--cellula--component--icon-button--color--hover-warning',
		value: `${colorTokens.colorWarning800.value}14`,
	},
	componentIconButtonActiveWarning: {
		cssVar: '--cellula--component--icon-button--color--active-warning',
		value: `${colorTokens.colorWarning800.value}1F`,
	},
	componentIconButtonHoverDanger: {
		cssVar: '--cellula--component--icon-button--color--hover-danger',
		value: `${colorTokens.colorDanger800.value}14`,
	},
	componentIconButtonActiveDanger: {
		cssVar: '--cellula--component--icon-button--color--active-danger',
		value: `${colorTokens.colorDanger800.value}1F`,
	},
};
